import type { TablerIcon } from '@rossum/ui/icons/tabler';
import { Box } from '@rossum/ui/material';
import {
  DOCUMENT_HISTORY_ICON_SIZE,
  DOCUMENT_HISTORY_ICON_STROKE,
} from '../constants';

// Renders a tabler icon at the drawer's Helene design-system spec (node 11781:98).
export const RowIcon = ({ icon }: { icon: TablerIcon }) => (
  <Box
    component={icon}
    size={DOCUMENT_HISTORY_ICON_SIZE}
    stroke={DOCUMENT_HISTORY_ICON_STROKE}
    sx={{ flexShrink: 0 }}
  />
);
